import { createContext, useContext } from 'react';

/*
 * A gate on the vignettes inside it, which usePlayback reads. Closed, a
 * vignette rests on its opening frame and does not start; open, it plays;
 * closed again mid-pass, it finishes that pass (its rest and the dip back to
 * the opening frame included) and rests there. Without a gate around it a
 * vignette is never held. Home's bento keeps each cell's gate closed until
 * the cell is hovered, where a pointer can hover (2026-10-04).
 */
const PlaybackGateContext = createContext(true);

export default function PlaybackGate({ open, children }) {
    return <PlaybackGateContext.Provider value={open}>{children}</PlaybackGateContext.Provider>;
}

/** Whether the gate around the caller is open (true without one). */
export const usePlaybackGate = () => useContext(PlaybackGateContext);
